import { IBase } from './base';

export interface IStore extends IBase {
  name: string;
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  country?: string;
  locale: string;
  expiring_soon_minutes?: number;
  properties?: Record<string, unknown>;
  timezone: string;
  olo_store_number: string;
  olo_brand_details?: Record<string, unknown>;
  expedite_print_template?: string;
  organization_id: string;
}
export class Store implements IStore {
  public name: string;
  public address?: string;
  public address2?: string;
  public city?: string;
  public state?: string;
  public postal_code?: string;
  public country?: string;
  public organization_id: string;
  public locale: string;
  public timezone: string;
  public expiring_soon_minutes?: number;
  public properties: Record<string, unknown> = { enable_order_creation_from_ui_app: false };
  public olo_store_number: string;
  public olo_brand_details?: Record<string, unknown>;
  public expedite_print_template?: string;
  public id: string;

  public constructor(args: IStore) {
    this.id = args.id;
    this.organization_id = args.organization_id;
    this.name = args.name;
    this.address = args.address;
    this.address2 = args.address2;
    this.city = args.city;
    this.state = args.state;
    this.postal_code = args.postal_code;
    this.country = args.country;
    this.locale = args.locale;
    this.timezone = args.timezone;
    this.expiring_soon_minutes = args.expiring_soon_minutes;
    this.properties = args.properties || { enable_order_creation_from_ui_app: false };
    this.olo_store_number = args.olo_store_number || '';
    this.olo_brand_details = args.olo_brand_details;
    this.expedite_print_template = args.expedite_print_template;
  }

  static create(args: IStore): Store {
    return new this(args);
  }

  static default(): IStore {
    const defaultStore: IStore = {
      name: 'New Store',
      address: '',
      address2: '',
      city: '',
      state: '',
      postal_code: '',
      country: '',
      locale: 'en',
      properties: { enable_order_creation_from_ui_app: false },
      timezone: 'Etc/UTC',
      organization_id: '',
      id: '',
      olo_store_number: ''
    };

    return defaultStore;
  }
}
